






























    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'
    import {EventBus, Messages, OrderBus, OrderMessages} from "../../services/EventBus";
    import TradingBlockRemote, {GetRefClientId} from "../../services/TradingBlockRemote";
    import {OrderStatus} from "../../domain/types";
    import {error, notify} from "../../utils/log";
    import WaitingIndicator from '../Common/WaitIndicator.vue'
    import {Order} from "../../domain/Order";
    //import store, {MUTATION_TYPES} from '../../store/index'

    @Component({
        components: {WaitingIndicator}
    })
    
    class OrderActionMenu extends Vue {
        @Prop()
        order: Order;

        get isChangeable(): boolean{
            return Order.isChangeable(this.order);
        }

        get isWorking(): boolean{
            return Order.isWorking(this.order);
        }



        show:boolean=false;

        cancelling: boolean = false;

        showMenu(){
           this.show= true;
        }
        hideMenu(){
            this.show= false;
        }

        @Emit()
        async tradeClick() {

            EventBus.showTradeForm(Order.makeTradeOrder(this.order));

            this.hideMenu()
        }

        @Emit()
        editClick() {
            //EventBus.$emit(<string>Messages.tradeOrderWindowShow, this.order);
            OrderBus.$emit(<string>OrderMessages.OrdersEditPrice, this.order);
            this.hideMenu()
        }

        @Emit()
        async cancelClick() {
            this.cancelling = true;
            //await store.dispatch('cancelOrder', this.order)
            var xhr = new TradingBlockRemote({ onComplete: this.CancelSuccess.bind(this), onFailure: this.CancelFail.bind(this) })
                .CancelOrder(Order.makeCancelRequest(this.order));
            this.hideMenu()
        }


//        closeClick() {
//            this.hideMenu()
//            EventBus.$emit(<string>Messages.tradeOrderWindowShow,Order.makeCloseOrder(this.order))
//
//        }

        CancelSuccess(){
            notify.log("Cancel Success");

            OrderBus.$emit(<string>OrderMessages.OrderCancelSuccess, this.order);
            this.cancelling = false;
        }

        CancelFail(){
            error.log("Cancel Fail");
            this.cancelling = false;
        }
    }

    export default OrderActionMenu;
